(() => {
  document.addEventListener('keydown', e => {
    const el = e.target;
    if (!el.matches?.('.descripcion-tarjeta') || el.scrollHeight <= el.clientHeight) return;
    const moves = {ArrowDown: 40, ArrowUp: -40, PageDown: el.clientHeight, PageUp: -el.clientHeight};
    if (e.key in moves) { e.preventDefault(); el.scrollTop += moves[e.key]; }
    if (e.key === 'Home') { e.preventDefault(); el.scrollTop = 0; }
    if (e.key === 'End') { e.preventDefault(); el.scrollTop = el.scrollHeight; }
  });
  document.querySelectorAll('[data-plano-upload]').forEach(input => {
    input.addEventListener('change', () => {
      const file = input.files[0];
      const allowed = input.name === 'planos_pdf' ? ['application/pdf'] : ['image/jpeg', 'image/png', 'image/webp'];
      input.setCustomValidity(file && (!allowed.includes(file.type) || file.size > Number(input.dataset.maxSize)) ? 'Revisa el formato y el tamaño máximo indicado.' : '');
      input.reportValidity();
    });
  });
  const dialog = document.getElementById('visor-planos');
  if (!dialog) return;
  const area = dialog.querySelector('.visor-area');
  const img = document.getElementById('visor-imagen');
  const output = document.getElementById('visor-escala');
  const error = document.getElementById('visor-error');
  let scale = 1, baseW = 0, baseH = 0, x = 0, y = 0, opener, oldOverflow;
  const points = new Map();
  function draw() {
    x = baseW * scale <= area.clientWidth ? (area.clientWidth - baseW * scale) / 2 : Math.max(area.clientWidth - baseW * scale, Math.min(0, x));
    y = baseH * scale <= area.clientHeight ? (area.clientHeight - baseH * scale) / 2 : Math.max(area.clientHeight - baseH * scale, Math.min(0, y));
    img.style.width = `${baseW}px`; img.style.height = `${baseH}px`;
    img.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    output.value = `${Math.round(scale * 100)}%`;
  }
  function reset() {
    if (!img.naturalWidth) return;
    const fit = Math.min(area.clientWidth / img.naturalWidth, area.clientHeight / img.naturalHeight, 1);
    baseW = img.naturalWidth * fit; baseH = img.naturalHeight * fit;
    scale = 1; x = 0; y = 0; draw();
  }
  function zoom(factor, cx = area.clientWidth / 2, cy = area.clientHeight / 2) {
    const next = Math.max(1, Math.min(8, scale * factor));
    x = cx - (cx - x) * next / scale; y = cy - (cy - y) * next / scale;
    scale = next; draw();
  }
  document.querySelectorAll('.abrir-plano').forEach(btn => btn.addEventListener('click', () => {
    opener = btn; points.clear(); error.textContent = '';
    document.getElementById('visor-titulo').textContent = btn.dataset.planoTitulo;
    img.alt = btn.dataset.planoTitulo; img.style.visibility = 'hidden';
    oldOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    dialog.showModal(); area.focus();
    img.onload = () => { reset(); img.style.visibility = 'visible'; };
    img.onerror = () => { error.textContent = 'No fue posible cargar el plano. Cierra el visor y vuelve a intentar.'; };
    img.src = btn.dataset.planoSrc;
  }));
  dialog.addEventListener('close', () => { points.clear(); document.body.style.overflow = oldOverflow; opener?.focus(); });
  dialog.querySelectorAll('[data-visor]').forEach(btn => btn.addEventListener('click', () => {
    const action = btn.dataset.visor;
    if (action === 'cerrar') dialog.close();
    if (action === 'reset') reset();
    if (action === 'mas') zoom(1.25);
    if (action === 'menos') zoom(.8);
  }));
  area.addEventListener('keydown', e => {
    if (!['+', '=', '-', '0', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    e.preventDefault();
    if (e.key === '+' || e.key === '=') zoom(1.25);
    if (e.key === '-') zoom(.8);
    if (e.key === '0') reset();
    if (e.key === 'ArrowLeft') x += 50;
    if (e.key === 'ArrowRight') x -= 50;
    if (e.key === 'ArrowUp') y += 50;
    if (e.key === 'ArrowDown') y -= 50;
    draw();
  });
  area.addEventListener('wheel', e => {
    e.preventDefault(); const r = area.getBoundingClientRect();
    zoom(e.deltaY < 0 ? 1.1 : 1 / 1.1, e.clientX - r.left, e.clientY - r.top);
  }, { passive: false });
  area.addEventListener('pointerdown', e => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    area.focus(); area.setPointerCapture(e.pointerId); points.set(e.pointerId, { x: e.clientX, y: e.clientY });
  });
  area.addEventListener('pointermove', e => {
    if (!points.has(e.pointerId)) return;
    const before = [...points.values()]; const prior = points.get(e.pointerId);
    points.set(e.pointerId, { x: e.clientX, y: e.clientY });
    const after = [...points.values()];
    if (points.size === 1) { x += e.clientX - prior.x; y += e.clientY - prior.y; draw(); }
    else if (points.size === 2) {
      const dist = p => Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      const r = area.getBoundingClientRect();
      const cx = (before[0].x + before[1].x) / 2, cy = (before[0].y + before[1].y) / 2;
      if (dist(before) > 0) zoom(dist(after) / dist(before), cx - r.left, cy - r.top);
      x += (after[0].x + after[1].x) / 2 - cx; y += (after[0].y + after[1].y) / 2 - cy; draw();
    }
  });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(event => area.addEventListener(event, e => points.delete(e.pointerId)));
  new ResizeObserver(() => { if (dialog.open) reset(); }).observe(area);
})();
